import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  PLATFORM_ID,
} from '@angular/core';
import { LabelType, Options } from '@angular-slider/ngx-slider';
import { Moment } from 'moment';
import { BuyflowSortFilterService } from '../../../core/services/buyflow-sort-filter.service';
import * as moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { isPlatformBrowser } from '@angular/common';
import { getFadeInTransition } from '../../../core/pure-functions/animations/ng-animations-provider';
import { ConstantMan } from '../../../core/services/constantMan';
import { ActivatedRoute, Router } from '@angular/router';
import { Category } from 'anchor-shared/lib/model/enum/vessel-category-types';
import { CategoryType2LabelMapping } from 'anchor-shared/lib/service/pure-functions/vessel-helper/CategoryType2LabelMapping';

@Component({
  selector: 'app-buyflow-sort-filter-control',
  templateUrl: './buyflow-sort-filter-control.component.html',
  styleUrls: ['./buyflow-sort-filter-control.component.scss'],
  animations: [getFadeInTransition(500)],
})
export class BuyflowSortFilterControlComponent implements OnInit {
  @Input()
  limits: BuyflowConfigLimits;

  @Input()
  previousValues: BuyflowVesselSortConfig;

  @Input()
  previousSortType: string[];

  @Input()
  isMobile: boolean;

  @Input()
  waterBodyName: string;

  @Input()
  availableOn: Moment;

  @Output()
  newSort = new EventEmitter<string[]>();

  @Output()
  mobileFilterChange = new EventEmitter<BuyflowVesselSortConfig>();

  config: BuyflowVesselSortConfig;
  sortType: string[];
  priceMinValue = FILTER_PRICE_MIN;
  priceMaxValue = FILTER_PRICE_MAX;
  lengthMinValue = FILTER_LENGTH_MIN;
  lengthMaxValue = FILTER_LENGTH_MAX;
  lengthFilterUsed: boolean = false;
  priceFilterUsed: boolean = false;
  passengersFilterUsed: boolean = false;
  boatCategoriesFilterUsed: boolean = false;
  priceOptions: Options;
  lengthOptions: Options;
  manualRefresh: EventEmitter<void>;
  moreFilterKeys: string[];
  isBrowser: boolean;
  settled = false;
  guestCount: string | number;

  sortOptions: VesselSortOption[] = [
    {
      value: ConstantMan.VESSEL_SORT_ORDER.PRICE_ASC,
      viewValue: 'Price Ascending',
    },
    {
      value: ConstantMan.VESSEL_SORT_ORDER.PRICE_DESC,
      viewValue: 'Price Descending',
    },
    {
      value: ConstantMan.VESSEL_SORT_ORDER.LENGTH_ASC,
      viewValue: 'Length Ascending',
    },
    {
      value: ConstantMan.VESSEL_SORT_ORDER.LENGTH_DESC,
      viewValue: 'Length Descending',
    },
  ];

  boatCategories: Category[] = [];

  public CategoryType2LabelMapping = CategoryType2LabelMapping;

  public CategoryTypes: Category[] = Object.values(Category) as Category[];

  initialized = false;

  constructor(
    private buyflowSortFilterService: BuyflowSortFilterService,
    @Inject(PLATFORM_ID) private platformId: any,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit() {
    this.manualRefresh = new EventEmitter<void>();

    this.initFilters();
    this.setFiltersFromSessionStorage();
    this.setFiltersFromQueryParams();
    this.moreFilterKeys = ['cabins', 'sleeps', 'showers', 'bathrooms'];
    this.settleMobileSliders();
    setTimeout(() => {
      this.modelChange(null, null);
    }, 1000);
  }

  watchGuestInput($event) {
    if ($event.target.value.includes('+')) {
      $event.target.value = $event.target.value.slice(0, -1);
    }
    if ($event.target.value < 0) {
      this.guestCount = this.config['passengers'] = 0;
    } else {
      this.guestCount = this.config['passengers'] = $event.target.value;
    }
    if (this.isMobile) {
      this.modelChange(null, null);
    }
  }

  boatCategoriesChange($event: any, boatCategory: Category): void {
    $event.stopPropagation();
    if (this.boatCategories.includes(boatCategory)) {
      let index = this.boatCategories.indexOf(boatCategory);
      if (index > -1) {
        this.boatCategories.splice(index, 1);
      }
    } else {
      this.boatCategories.push(boatCategory);
    }
    if (this.isMobile) this.modelChange(true, null);
  }

  boatCategorySelected(boatCategory: string): boolean {
    const categories: string[] = this.boatCategories;

    if (categories?.includes(boatCategory)) {
      return true;
    } else {
      return false;
    }
  }

  modelChange(isApplyButton = false, filterType: string): void {
    if (filterType === 'boatLength') {
      this.lengthFilterUsed = true;
    } else if (filterType === 'price') {
      this.priceFilterUsed = true;
    } else if (filterType === 'passengers') {
      this.passengersFilterUsed = true;
    } else if (filterType === 'boatCategories') {
      this.boatCategoriesFilterUsed = true;
    }

    if (this.priceMaxValue === BUYFLOW_PRICE_MAX) {
      this.priceMaxValue = FILTER_PRICE_MAX;
    }

    if (this.lengthMaxValue === BUYFLOW_LENGTH_MAX) {
      this.lengthMaxValue = FILTER_LENGTH_MAX;
    }

    const filters = {
      priceMin: this.priceMinValue,
      priceMax: this.priceMaxValue,
      availableOn: this.config.availableOn,
      passengers: this.config.passengers,
      boatLengthMin: this.lengthMinValue,
      boatLengthMax: this.lengthMaxValue,
      cabins: this.config.cabins,
      sleeps: this.config.sleeps,
      showers: this.config.showers,
      bathrooms: this.config.bathrooms,
      categories: this.boatCategories,
    };

    if (isApplyButton) {
      const queryParams = {};

      if (this.priceMinValue >= 0) {
        queryParams['priceMin'] = this.priceMinValue;
        sessionStorage.setItem('priceMin', this.priceMinValue.toString());
      }
      if (this.priceMaxValue >= 0) {
        queryParams['priceMax'] = this.priceMaxValue;
        sessionStorage.setItem('priceMax', this.priceMaxValue.toString());
      }
      if (this.config?.availableOn) {
        queryParams['availableOn'] = this.config.availableOn;
      }
      if (this.config?.passengers >= 0) {
        queryParams['passengers'] = this.config.passengers;
        sessionStorage.setItem('passengers', this.config.passengers.toString());
      }
      if (this.lengthMinValue >= 0) {
        queryParams['boatLengthMin'] = this.lengthMinValue;
        sessionStorage.setItem('boatLengthMin', this.lengthMinValue.toString());
      }
      if (this.lengthMaxValue) {
        queryParams['boatLengthMax'] = this.lengthMaxValue;
        sessionStorage.setItem('boatLengthMax', this.lengthMaxValue.toString());
      }

      if (this.boatCategories) {
        queryParams['categories'] = JSON.stringify(this.boatCategories);
        sessionStorage.setItem(
          'categories',
          JSON.stringify(this.boatCategories),
        );
      }

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: queryParams,
        queryParamsHandling: 'merge',
      });
    }

    if (this.isMobile) {
      this.mobileFilterChange.emit(filters);
    } else {
      // this handles initial load of vessels
      this.buyflowSortFilterService.getBuyflowFilter().next(filters);
    }
  }

  sortTypeChange(): void {
    this.newSort.emit(this.sortType);
  }

  dateFilter = (incomingMoment: Moment): boolean => {
    if (incomingMoment.isSame(moment(), 'day')) {
      return true;
    }
    if (incomingMoment.isBefore(moment())) {
      return false;
    }
    return true;
  };

  menuToggle(value: boolean) {
    setTimeout(() => {
      this.manualRefresh.emit();
    }, 400);
  }

  noClickable($event: MouseEvent) {
    $event.stopPropagation();
  }

  clearFilter(filterType: string) {
    if (filterType === 'boatLength') {
      this.lengthMinValue = this.limits.minBoatLength;
      this.lengthMaxValue = this.limits.maxBoatLength;
      this.lengthFilterUsed = false;
    } else if (filterType === 'price') {
      this.priceMinValue = this.limits.halfDayMinPrice;
      this.priceMaxValue = this.limits.halfDayMaxPrice;
      this.priceFilterUsed = false;
    } else if (filterType === 'boatCategories') {
      this.boatCategories = [];
      this.boatCategoriesFilterUsed = false;
    } else if (filterType === 'passengers') {
      this.passengersFilterUsed = false;
      this.config[filterType] =
        this.limits[
          'min' + filterType.charAt(0).toUpperCase() + filterType.slice(1)
        ];
    }
    this.modelChange(true, null);
  }

  private createConfig(
    limits: BuyflowConfigLimits,
    availableOn?: Moment,
  ): void {
    this.config = {
      priceMin: limits.halfDayMinPrice,
      priceMax: limits.halfDayMaxPrice,
      availableOn: availableOn,
      passengers: limits.minPassengers,
      boatLengthMin: limits.minBoatLength,
      boatLengthMax: limits.maxBoatLength,
      // To add another filter to "more filters", put on the bottom of this list
      cabins: limits.minCabins,
      sleeps: limits.minSleeps,
      showers: limits.minShowers,
      bathrooms: limits.minBathrooms,
    };
  }

  private initFilters() {
    if (this.previousSortType) {
      this.sortType = this.previousSortType;
    }
    if (this.previousValues) {
      this.priceMinValue = this.previousValues.priceMin;
      this.priceMaxValue = this.previousValues.priceMax;
      this.lengthMinValue = this.previousValues.boatLengthMin;
      this.lengthMaxValue = this.previousValues.boatLengthMax;
      this.boatCategories = this.previousValues.categories;
    } else {
      this.priceMinValue = this.limits.halfDayMinPrice;
      this.priceMaxValue = this.limits.halfDayMaxPrice;
      this.lengthMinValue = this.limits.minBoatLength;
      this.lengthMaxValue = this.limits.maxBoatLength;
      this.boatCategories = [];
    }
    this.priceOptions = {
      floor: 0,
      enforceStep: false,
      ceil: this.limits.halfDayMaxPrice,
      step: 10,
      hidePointerLabels: true,
      hideLimitLabels: true,
      getPointerColor: (): string => {
        return '#167C73';
      },
      getSelectionBarColor: (): string => {
        return '#167C73';
      },
    };
    this.lengthOptions = {
      floor: this.limits.minBoatLength,
      ceil: this.limits.maxBoatLength,
      translate: (value: number, label: LabelType): string => {
        switch (label) {
          case LabelType.High:
            if (value === BUYFLOW_LENGTH_MAX) {
              return value + '+ ft';
            }
            return value + 'ft';
          default:
            return value + 'ft';
        }
      },
      getPointerColor: (): string => {
        return '#167C73';
      },
      getSelectionBarColor: (): string => {
        return '#167C73';
      },
    };
    if (this.previousValues) {
      this.config = this.previousValues;
    } else {
      this.createConfig(this.limits, this.availableOn);
    }
  }

  private settleMobileSliders(): void {
    setTimeout(() => {
      this.settled = true;
    }, 500);
  }

  private setFiltersFromQueryParams() {
    let priceMax = Number(this.route.snapshot.queryParamMap.get('priceMax'));
    if (priceMax < this.limits.halfDayMaxPrice && priceMax > 0) {
      this.priceMaxValue = priceMax;
      this.priceFilterUsed = true;
    }
    let priceMin = Number(this.route.snapshot.queryParamMap.get('priceMin'));
    if (priceMin > this.limits.halfDayMinPrice && priceMin > 0) {
      this.priceMinValue = priceMin;
      this.priceFilterUsed = true;
    }
    let passengers = Number(
      this.route.snapshot.queryParamMap.get('passengers'),
    );
    if (passengers > this.limits.minPassengers && passengers > 0) {
      this.config.passengers = passengers;
      this.passengersFilterUsed = true;
    }
    let minLength = Number(
      this.route.snapshot.queryParamMap.get('boatLengthMin'),
    );
    if (minLength > this.limits.minBoatLength && minLength > 0) {
      this.lengthMinValue = minLength;
      this.lengthFilterUsed = true;
    }
    let maxLength = Number(
      this.route.snapshot.queryParamMap.get('boatLengthMax'),
    );
    if (maxLength < this.limits.maxBoatLength && maxLength > 0) {
      this.lengthMaxValue = maxLength;
      this.lengthFilterUsed = true;
    }
    if (JSON.parse(this.route.snapshot.queryParamMap.get('categories'))) {
      this.boatCategories = JSON.parse(
        this.route.snapshot.queryParamMap.get('categories'),
      ) as Category[];
      if (this.boatCategories.length > 0) {
        this.boatCategoriesFilterUsed = true;
      }
    }
  }

  private setFiltersFromSessionStorage() {
    if (!this.isBrowser) return;
    if (sessionStorage.getItem('priceMin')) {
      this.priceMinValue = Number(sessionStorage.getItem('priceMin'));
      if (this.priceMinValue) this.priceFilterUsed = true;
    }
    if (sessionStorage.getItem('priceMax')) {
      this.priceMaxValue = Number(sessionStorage.getItem('priceMax'));
      if (
        this.priceMaxValue < this.limits.halfDayMaxPrice &&
        this.priceMaxValue > 0
      ) {
        this.priceFilterUsed = true;
      }
    }
    if (sessionStorage.getItem('passengers')) {
      this.guestCount = this.config.passengers = Number(
        sessionStorage.getItem('passengers'),
      );
      if (this.guestCount > 0) this.passengersFilterUsed = true;
    }

    if (sessionStorage.getItem('boatLengthMin')) {
      this.lengthMinValue = Number(sessionStorage.getItem('boatLengthMin'));
    }
    if (sessionStorage.getItem('boatLengthMax')) {
      this.lengthMaxValue = Number(sessionStorage.getItem('boatLengthMax'));
    }

    if (
      (this.lengthMinValue > this.limits.minBoatLength &&
        this.lengthMinValue > 0) ||
      (this.lengthMaxValue < this.limits.maxBoatLength &&
        this.lengthMaxValue > 0)
    ) {
      this.lengthFilterUsed = true;
    }

    if (sessionStorage.getItem('categories')) {
      this.boatCategories = JSON.parse(sessionStorage.getItem('categories'));
      if (this.boatCategories?.length > 0) {
        this.boatCategoriesFilterUsed = true;
      }
    }
  }
}

export interface BuyflowConfigLimits {
  maxBathrooms: number;
  minBathrooms: number;
  maxSleeps: number;
  minSleeps: number;
  maxShowers: number;
  minShowers: number;
  minCabins: number;
  maxCabins: number;
  minPassengers: number;
  maxPassengers: number;
  minBoatLength: number;
  maxBoatLength: number;
  halfDayMinPrice: number;
  halfDayMaxPrice: number;
}

export interface BuyflowVesselSortConfig {
  priceMin: number;
  priceMax: number;
  availableOn: Moment;
  passengers: number;
  boatLengthMin: number;
  boatLengthMax: number;
  cabins: number;
  sleeps: number;
  showers: number;
  bathrooms: number;
  categories?: Category[];
}

export const BUYFLOW_PRICE_MAX = 4000;
export const BUYFLOW_LENGTH_MAX = 125;

export const FILTER_PRICE_MIN = 10;
export const FILTER_PRICE_MAX = 200000;
export const FILTER_LENGTH_MIN = 10;
export const FILTER_LENGTH_MAX = 500;

export interface VesselSortOption {
  value: string[];
  viewValue: string;
}
